import Emitter from "./Emitter";

export default class RequestLogin extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: "showLogin" });
    }

    _default() {
        this.emitTop({ wpgaction: "login" });
        this.emitParent({ wpgaction: "login.parent" });
        this.emitiOS({ wpgaction: "login" });

    }
}
